import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5c0f925dd08a0014778d16_1784505520566_76676b92/tactilescale/src/app/not-found.tsx");
